<script setup>
import { cn } from "@/Utils/cn";

const props = defineProps({
  class: { type: null, required: false },
});
</script>

<template>
  <div
    :class="
      cn('flex gap-y-1.5 justify-between items-center text-left', props.class)
    "
  >
    <div class="flex flex-col gap-1 w-full">
      <slot />
    </div>
  </div>
</template>
